import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {websiteUserEdit_template} from "../components/templates/websiteUserEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {infoButton_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";

declare var ko: any;
declare var page: any;

export class website_users_edit extends vnModule_knockoutJS{
    protected websiteUser : websiteUserEdit_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.websiteUser = new websiteUserEdit_template('websiteUser', this.viewModel, this)
        return [this.websiteUser.build()]
    }

    protected getModuleName(): string {
        return "website_users_edit";
    }

    public fillPage() {
        this.getReferences();

    }

    protected getReferences() {

        // LOADING : starts
        this.loadingIn(this.websiteUser.builtTemplate);

        let usrReq_url: string = '/api/website-users/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();

    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.websiteUser.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);
                obj.websiteUser.setPermissions(responseParsed.permissions);

                //get website user
                obj.getWebsiteUserDataForEdit();
            })
        }
    }

    private getWebsiteUserDataForEdit() {

        this.loadingIn(this.websiteUser.builtTemplate);

        let url : string = '/api/website-users/get/' + this.getVnAppZone().app.params.idWebsiteUser + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetWebsiteUserDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetWebsiteUserDataForEdit(req, obj) {

        return function () {

            if(req.request.readyState === 4){

                let responseParsed = JSON.parse(req.request.response);

                if (responseParsed && responseParsed && ('websiteUser' in responseParsed) && ('mailingListOptions' in responseParsed)) {
                    obj.setWebsiteUserData(responseParsed);
                } else if (req.request.status == 423) {

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    page.redirect('/website-users/');
                }else {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Website User not found !");
                    page.redirect('/website-users/');
                }
            };

            obj.loadingOut(obj.websiteUser.builtTemplate);
        }
    }

    protected setWebsiteUserData(websiteUserData) {


        let fullName = '';
        let accessPointUsers : any = [];
        if (typeof websiteUserData.websiteUser.accessPointUsers !== "undefined" && websiteUserData.websiteUser.accessPointUsers.length > 0) {

            for (let i = 0; i < websiteUserData.websiteUser.accessPointUsers.length; i++) { // set the Full Namein the table to the first fullName value we find
                if (websiteUserData.websiteUser.accessPointUsers[i].fullName && websiteUserData.websiteUser.accessPointUsers[i].fullName.trim() !== '') {
                    fullName = websiteUserData.websiteUser.accessPointUsers[i].fullName;
                    break;
                }
            }

            // Add all the available mailing list options to the accessPointUser for 'simplicity'
            for (let i = 0; i < websiteUserData.websiteUser.accessPointUsers.length; i++) {

                let accessPointMailingLists = [];
                let relevantMailingLists = [];

                let accessPointUser = websiteUserData.websiteUser.accessPointUsers[i];
                accessPointUser.hasBrandAccess = !websiteUserData.accessibleBrandIds || accessPointUser.accessPoint.brands.every((brand) => websiteUserData.accessibleBrandIds.includes(Number(brand.id)));
                accessPointUser.costumProfilePictureObservable = ko.observable(null);
                accessPointUser.accessPointIndex = ko.observable(i);
                let brandPremiumFreeEndDate = null;
                if(accessPointUser.premiumFreeEndDate != null){
                    brandPremiumFreeEndDate = accessPointUser.premiumFreeEndDate;
                }else{
                    const now = new Date();
                    const nextMonth = new Date(now);
                    nextMonth.setMonth(now.getMonth() + 1);
                    brandPremiumFreeEndDate = nextMonth.toISOString().split('T')[0];
                }
                accessPointUser.singleDatePicker = ko.observable(brandPremiumFreeEndDate);
                accessPointUser.idPicker= ko.observable("premium-free-end-date" + accessPointUser.accessPoint.id);
                accessPointUser.showClearDatesButton = ko.observable(false);
                accessPointUser.onClickClearDatePicker = function(data, event) { this.onClickClearDatePicker(); }
                accessPointUser.isPickerDisabled = ko.observable(false);
                accessPointUser.isPremiumFree = ko.observable(accessPointUser.isPremiumFree);         
                accessPointUser.newsletterTargetingDetails = ko.observable(null);
                accessPointUser.newsletterTargetingIsLoading = ko.observable(false);

                accessPointUser.pendingDisplayNameStatus = '';
                if(websiteUserData.displayName) {
                    accessPointUser.pendingDisplayNameStatus = 'Approved';
                }
                if(websiteUserData.displayNameModeration && websiteUserData.displayNameModeration[accessPointUser.id]) {
                    accessPointUser.pendingDisplayName = websiteUserData.displayNameModeration[accessPointUser.id].pendingDisplayName;
                    accessPointUser.pendingDisplayNameStatus = websiteUserData.displayNameModeration[accessPointUser.id].status ? websiteUserData.displayNameModeration[accessPointUser.id].status.name : 'Submitted';
                }

                accessPointUser.customDisplayImageStatus = '';
                if(websiteUserData.displayImageModeration) {
                    accessPointUser.customDisplayImageStatus = accessPointUser.isCustomProfilePictureValidated ? 'Approved' : 'Submitted';
                }
                if(websiteUserData.displayImageModeration && websiteUserData.displayImageModeration[accessPointUser.id] && websiteUserData.displayImageModeration[accessPointUser.id].systemModerationOutcome) {
                    accessPointUser.customDisplayImageStatus = websiteUserData.displayImageModeration[accessPointUser.id].systemModerationOutcome.description;
                }
                if(accessPointUser.customDisplayImageStatus) {
                    accessPointUser.customDisplayImageStatusClass = accessPointUser.customDisplayImageStatus.split(' ')[0].toLowerCase();
                }

                accessPointUser.coverImageStatus = '';
                if(websiteUserData.coverImageModeration) {
                    accessPointUser.coverImageStatus = accessPointUser.isCoverImageValidated ? 'Approved' : 'Submitted';
                }
                if(websiteUserData.coverImageModeration && websiteUserData.coverImageModeration[accessPointUser.id] && websiteUserData.coverImageModeration[accessPointUser.id].systemModerationOutcome) {
                    accessPointUser.coverImageStatus = websiteUserData.coverImageModeration[accessPointUser.id].systemModerationOutcome.description;
                }
                if(accessPointUser.coverImageStatus) {
                    accessPointUser.coverImageStatusClass = accessPointUser.coverImageStatus.split(' ')[0].toLowerCase();
                }

                accessPointUsers.push(accessPointUser);

                for (let accessPointBrand of websiteUserData.websiteUser.accessPointUsers[i].accessPoint.brands) {
                    relevantMailingLists = websiteUserData.mailingListOptions.filter(
                        a => a.idBrand == accessPointBrand.id
                    );
                    accessPointMailingLists = accessPointMailingLists.concat(relevantMailingLists);
                }

                let brandDomain = websiteUserData.websiteUser.accessPointUsers[i].accessPoint.brands[0].domain;
                let idProfile = websiteUserData.websiteUser.accessPointUsers[i].idProfile;
               // let premiumFreeEndDate = websiteUserData.websiteUser.accessPointUsers[i].premiumFreeEndDate;


                // Ensure brand_domain includes the protocol
                if (!/^https?:\/\//i.test(brandDomain)) {
                    brandDomain = 'https://' + brandDomain;
                }
                websiteUserData.websiteUser.accessPointUsers[i].profilePageLink = brandDomain + "/profile/" + idProfile;

                websiteUserData.websiteUser.accessPointUsers[i].accessPointMailingLists = accessPointMailingLists;

                websiteUserData.websiteUser.accessPointUsers[i].isPrimaryMailingListSelected = false;

                for (let z = 0; z < websiteUserData.websiteUser.accessPointUsers[i].accessPointMailingLists.length; z++) {
                    // check if the mailinglist is active in the user's preferences
                    let isMailingListActive = websiteUserData.websiteUser.accessPointUsers[i].mailingListPreferences.some(
                        a => (a.idMailingList == websiteUserData.websiteUser.accessPointUsers[i].accessPointMailingLists[z].id && a.isActive)
                    );// if so indicated in the full list of available mailing lists for the brands..

                    if(isMailingListActive && websiteUserData.websiteUser.accessPointUsers[i].accessPointMailingLists[z].isPrimary){
                        websiteUserData.websiteUser.accessPointUsers[i].isPrimaryMailingListSelected = true;
                    }

                    websiteUserData.websiteUser.accessPointUsers[i].accessPointMailingLists[z].isUserActive = isMailingListActive;
                }

                //premium subscriptions
                let subscriptions = websiteUserData.websiteUser.accessPointUsers[i].subscriptions;
                if(subscriptions && subscriptions.length > 0){

                    //sort by id
                    subscriptions.sort((sub1, sub2) => sub2.id - sub1.id);

                    //set tooltip for cancel and revoke on each apu if has premium subscription
                    let cancelSubscriptionToolTipButton = new infoButton_template('cancelSubscriptionToolTip_index'+i, this.websiteUser.builtTemplate, this)
                    cancelSubscriptionToolTipButton.setTitle('Cancel Subscription');
                    cancelSubscriptionToolTipButton.setContent('<p>Canceling a website user’s subscription will disable recurring payments. They will still have access to premium privileges until their current subscription plan’s end date is reached.</p>');

                    let revokeSubscriptionToolTipButton = new infoButton_template('revokeSubscriptionToolTip_index'+i, this.websiteUser.builtTemplate, this)
                    revokeSubscriptionToolTipButton.setTitle('Revoke Subscription');
                    revokeSubscriptionToolTipButton.setContent('<p>Revoking a website user’s premium privileges will set the end date of their plan to now. They will immediately lose premium privileges regardless of their plan..</p>');

                    websiteUserData.websiteUser.accessPointUsers[i].cancelSubscriptionTooltip = cancelSubscriptionToolTipButton;
                    websiteUserData.websiteUser.accessPointUsers[i].revokeSubscriptionTooltip = revokeSubscriptionToolTipButton;

                    //update subscriptions
                    websiteUserData.websiteUser.accessPointUsers[i].subscriptions = subscriptions;
                }
                //let hasPremiumFree = (subscriptions || []).some(sub => sub.type === 'premium_free');
                //accessPointUser.isPremiumFree = ko.observable(hasPremiumFree);
                this.loadNewsletterTargetingDetails(accessPointUser);

            }
        }

        let isEmakiUserString = websiteUserData.websiteUser.isEmakiUser ? 'true' : 'false';

        this.websiteUser.setAccessPointUsers(websiteUserData.websiteUser.accessPointUsers);
        //this.websiteUser.setMailingListOptions(accessPointMailingLists);
        this.websiteUser.setId(websiteUserData.websiteUser.id);
        this.websiteUser.setFullName(fullName);
        this.websiteUser.setIsEmakiUser(isEmakiUserString);
        this.websiteUser.setDateCreated(websiteUserData.websiteUser.dateCreatedFormat);
        this.websiteUser.setEmail(websiteUserData.websiteUser.email);
        this.websiteUser.buildDatePickerCalendar(websiteUserData.websiteUser.accessPointUsers);
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public loadNewsletterTargetingDetails(accessPointUser): void {
        accessPointUser.newsletterTargetingIsLoading(true);
        let url = '/api/website-users/newsletter-targeting/access-point-user/' + accessPointUser.id + '/';
        let XHRHdl = new XMLHttpRequestHandler(url, [], this);
        XHRHdl.onReadyStateFunction = function (req, obj) {
            return function () {
                obj.manageResponse(req, obj, function () {
                    accessPointUser.newsletterTargetingDetails(JSON.parse(req.request.response));
                });
                accessPointUser.newsletterTargetingIsLoading(false);
            };
        };
        XHRHdl.execute();
    }

    public onClickCancelEdit(){

        this.releaseLock();
        page.redirect("/website-users/")
    }

    public getAssocBrandMailingLists(mailinglists) {
        return mailinglists.reduce((acc, item) => {
            let key = item.idBrand;
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {});
    }

    private removeAccessPointTooltips(viewModel: { accessPointUsers?: any }): void {
        if (!viewModel.accessPointUsers) return;

        for (const accessPointUser of viewModel.accessPointUsers()) {
            this.deleteTooltips(accessPointUser);
        }
    }

    private deleteTooltips(accessPointUser: { cancelSubscriptionTooltip?: any; revokeSubscriptionTooltip?: any }): void {
        delete accessPointUser.cancelSubscriptionTooltip;
        delete accessPointUser.revokeSubscriptionTooltip;
    }


    protected save(){
        this.loadingIn(this.websiteUser.builtTemplate);

        const idWebsiteUser = this.getVnAppZone().getApp().params.idWebsiteUser;

        const formReq_url: string = '/api/website-users/save/' + idWebsiteUser;
        const formReq_params: string[][] = [];

        const viewModel = this.websiteUser.getTemplateViewModel();
        this.removeAccessPointTooltips(viewModel);

        const websiteUserObject = { websiteUser : ko.toJS(viewModel) };
        formReq_params.push(["data", ko.toJSON(websiteUserObject)]);

        const XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    // @TODO hate this approach
                    obj.releaseLock();
                    page.redirect('/website-users/');

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Website User saved !");
                        // obj.getVnAppZone().showNotificationToModule();
                    }

                });
                obj.loadingOut(obj.websiteUser.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected releaseLock() {

        // request a lock release
        let usrReq_url: string = '/api/website-users/release/' + this.getVnAppZone().getApp().params.idWebsiteUser;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    protected updateSubscription(){

        this.loadingIn(document.getElementsByClassName("w-form lightbox-form")[0]);

        let idWebsiteUser = this.getVnAppZone().getApp().params.idWebsiteUser;
        let formReq_url: string = '/api/website-users/subscription/update/'+ idWebsiteUser;
        let formReq_params: Array<Array<string>> = [];

        let data = {
            'actionType': this.websiteUser.getTemplateViewModel().subscriptionAction,
            'subscription': this.websiteUser.getTemplateViewModel().subscriptionToUpdate
        }

        let subViewModel = JSON.parse(ko.toJSON(data));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/website-users/edit/' + idWebsiteUser);

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Subscription Updated !");
                    }
                });
                document.getElementById("confirm-dialog").classList.remove("is-visible");
                obj.loadingOut(document.getElementsByClassName("w-form lightbox-form")[0]);
            }
        });
        XHRHdl.execute();
    }

    public moderateDisplayName(idAccessPointUser, moderationType) {

        let usrReq_url: string = `/api/website-users/content-moderation/access-point-user/${idAccessPointUser}/display-name/${moderationType}/`;
        let subViewModel = {};

        this.sendFilterCall(usrReq_url, subViewModel, this.onDisplayNameModerationReturn, XMLHttpRequestHandler_requestType.POST, 'moderateDisplayName');
    }

    private onDisplayNameModerationReturn(req, obj) {
        return function () {

            obj.manageResponse(req, obj, function () {
                let accessPointUser = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    obj.websiteUser.updateAccessPointUserDisplayName(accessPointUser);
                }
            });
        }
    }

    public moderateDisplayImage(idAccessPointUser, moderationType) {
        let usrReq_url: string = `/api/website-users/content-moderation/access-point-user/${idAccessPointUser}/display-image/${moderationType}/`;
        let subViewModel = {};

        this.sendFilterCall(usrReq_url, subViewModel, this.onDisplayImageModerationReturn, XMLHttpRequestHandler_requestType.POST, 'moderateDisplayImage');
    }

    private onDisplayImageModerationReturn(req, obj) {
        return function () {

            obj.manageResponse(req, obj, function () {
                let accessPointUser = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    obj.websiteUser.updateAccessPointUserDisplayImage(accessPointUser);
                }
            });
        }
    }

    public moderateCoverImage(idAccessPointUser, moderationType) {
        let usrReq_url: string = `/api/website-users/content-moderation/access-point-user/${idAccessPointUser}/cover-image/${moderationType}/`;
        let subViewModel = {};

        this.sendFilterCall(usrReq_url, subViewModel, this.onCoverImageModerationReturn, XMLHttpRequestHandler_requestType.POST, 'moderateCoverImage');
    }

    private onCoverImageModerationReturn(req, obj) {
        return function () {

            obj.manageResponse(req, obj, function () {
                let accessPointUser = JSON.parse(req.request.response);

                if (req.request.status == 200) {
                    obj.websiteUser.updateAccessPointUserCoverImage(accessPointUser);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./js/modules/website_users_edit.ts